import { useState } from "react";
import { Dropdown, FormControl, Spinner } from "react-bootstrap";
import axios from "axios";

import DashboardUser from "../typings/DashboardUser";
import SetState from "../typings/SetState";

type SearchDropdownProps = {
  title: string;
  dropdownItems: React.ReactNode;
  setData: SetState<DashboardUser[]>;
  fetchURL: string;
};

const SearchDropdown = ({
  title,
  dropdownItems,
  setData,
  fetchURL,
}: SearchDropdownProps) => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] =
    useState<ReturnType<typeof setTimeout>>();
  const [error, setError] = useState(false);

  const fetchData = async (name: string) => {
    try {
      const res = await axios.get<DashboardUser[]>(fetchURL + name);
      setData(res.data);
    } catch (err) {
      setError(true);
    }
  };

  const onSearch = (text: string) => {
    setSearch(text);
    if (text.length === 0) setData([]);
    if (text.length > 2) {
      setLoading(true);
      if (typingTimeout) clearTimeout(typingTimeout);
      setTypingTimeout(
        setTimeout(() => {
          fetchData(text);
          setLoading(false);
        }, 1500)
      );
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        style={{ backgroundColor: "#222c4a", borderColor: "#222c4a" }}
        size="sm"
        id="dropdown-basic"
      >
        {title}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type 3 letters to search..."
          onChange={(e) => onSearch(e.target.value)}
          value={search}
        />
        {loading ? (
          <Spinner
            animation="border"
            style={{ position: "relative", top: "50%", left: "50%" }}
          />
        ) : error ? (
          <p>Error while fecthing data. Try again.</p>
        ) : (
          dropdownItems
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchDropdown;
